export default "__VITE_ASSET__BmIfFYSl__"